module.exports = __webpack_public_path__ + "static/moonamar-hladno-cijedeno-djevicansko-laneno-ulje-5b429b65a0340e8c107c250d5261f6e4.png";